var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"CuckooTools-Footer"},[_vm._v(" © 2021 Cuckoo Tools All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }